import { useRepo } from 'pinia-orm';
import { User } from 'src/modules/User/models/User';
import { ref } from 'vue';

const userRepo = useRepo(User);
const currentUser = ref<User>();

export function useCurrentUser(
  currentUserId: number,
  withRelation: 'all' | 'role' | 'profile' | 'children' = 'all',
) {
  if (withRelation === 'all') {
    currentUser.value = userRepo.withAll().find(currentUserId) as User;
  } else {
    currentUser.value = userRepo.with(withRelation).find(currentUserId) as User;
  }

  return currentUser;
}
